import React from 'react';
import AboutHero from '../components/AboutHero';
import AboutWhoWeAre from '../components/AboutWhoWeAre';
import AboutTimeline from '../components/AboutTimeline';
import AboutGuidingPillars from '../components/AboutGuidingPillars';
import AboutMissionVision from '../components/AboutMissionVision';
import AboutTeamShowcase from '../components/AboutTeamShowcase';
import AboutLocation from '../components/AboutLocation';
import ClientPartners from '../components/ClientPartners';


const AboutPage = () => {
  return (
    <div>
      <AboutHero />
      <AboutWhoWeAre />
      <AboutTimeline />
      <AboutGuidingPillars />
      <AboutMissionVision />
      {/* <AboutTeamShowcase /> */}
      <ClientPartners />
      <AboutLocation />
    </div>
  );
};

export default AboutPage;
